import { render } from "./staffManager.vue?vue&type=template&id=6f824f22&scoped=true&ts=true"
import script from "./staffManager.vue?vue&type=script&lang=ts"
export * from "./staffManager.vue?vue&type=script&lang=ts"

import "./staffManager.vue?vue&type=style&index=0&id=6f824f22&lang=scss&scoped=true"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f824f22"]])

export default __exports__